export const SHOW_MORE_TEXT = '... Show more';
export const SHOW_LESS_TEXT = 'Show less';

export const CL_BROKER_LABEL = 'Commercial Lines Broker';

export const SELF_FUNDED_PC_TOOLTIP = 'Self Funded for Commercial Lines';

export const SELF_FUNDED_INFO_BUBBLE_TEXT =
  'This employer is Self Funded on some or all of their Commercial Lines policies or Health & Welfare program. This employer understands the concept of assuming risk. They could be a good candidate for Retro, Self Insured or Captive types of Alternative Risk Financing.';

export const POLICIES_INFO_BUBBLE_TEXT =
  'This column shows a summary of the types of Commercial Lines Insurance Policies for each company. You can reveal more details by clicking the > icon above.';

export const LOB_INCLUDED_CHIP_TEXT = 'Lines of business includes';
export const LOB_EXCLUDED_CHIP_TEXT = 'Lines of business excludes';

export const LOB_FREE_FORM_LABEL = 'Other Insurance Lines of Business';
export const LOB_FREE_FORM_TOOLTIP_TEXT =
  'Searches only the line of business values manually entered in the "Other" checkbox, which can be found on the Schedule A, as part of the Form 5500 filings.';
export const LOB_FREE_FORM_GHOST_TEXT = 'Search for any text such as pharmacy, pharma, rx, etc.';
export const LOB_INCLUDE_TOOLTIP_TEXT =
  'Searches brokers and broker locations that have at least one client that has the selected line(s) of business.';
export const LOB_EXCLUDE_TOOLTIP_TEXT =
  'Searches brokers and broker locations that have at least one client that does not have the selected line(s) of business.';
export const PROPERTY_PROFILE_TOOLTIP_TEXT =
  'The property profile for this company is based on the physical location of the primary premises shown on the map.';
export const HAZARD_PROFILE_TOOLTIP_TEXT =
  'The risk profile for this company is calculated for flood, fire, wind, ground, and crime hazards based on the physical location of the primary premises shown on the map.';
export const MOTOR_CARRIER_TOOLTIP_TEXT =
  'The Motor Carrier Information panel shows details about the company motor vehicle operations. A company will be flagged inactive if their USDOT operating authority has been deactivated.';

// NAICS Button Constants
export const NAICS_BUTTON_TEXT = 'Look up NAICS codes';

// Carrier Search Placeholder Text
export const CARRIER_SEARCH_TEXT = 'Enter reported carrier';

export const NO_RESULTS_TEXT = 'We currently have no data for this item.';
